import { addChargingDeviceConnectorsAPI } from "../../actions/chargingDevice/addChargingDeviceConnectors";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  addChargingDeviceConnector: {},
  loading: false,
  error: { code: "", message: "" },
};

const addChargingDeviceConnectorsSlice = createSlice({
  name: "addChargingDeviceConnectors",
  initialState,
  reducers: {
    resetUserData: (state) => {
      state = initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addChargingDeviceConnectorsAPI.pending, (state) => {
        state.loading = true;
      })
      .addCase(addChargingDeviceConnectorsAPI.fulfilled, (state, action) => {
        state.addChargingDeviceConnector = action.payload.data;
        state.loading = false;
      })
      .addCase(addChargingDeviceConnectorsAPI.rejected, (state, action) => {
        state.error = action.payload.error;
        state.loading = false;
      });
  },
});

export const { resetUserData } = addChargingDeviceConnectorsSlice.actions;
export default addChargingDeviceConnectorsSlice.reducer;
